import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import { CalendarContext } from './index.context';
import { reducer, initialState } from './index.reducer';
import { StyledCalendar, StyledControllers } from './index.styles';
import { Years } from './Years';
import { Months } from './Months';
import { Days } from './Days';

const currentDate = new Date();

export const init = ({ defaultDate, maxYear, minYear }) => {
    const match = /(\d+)\/(\d+)\/(\d+)/.exec(defaultDate) || [];
    const date = new Date(match[3], match[2] - 1, match[1]);

    if (date && !Number.isNaN(date.getTime())) {
        return {
            ...initialState,
            maxYear,
            minYear,
            date,
            selectedDate: date,
        };
    }

    return {
        ...initialState,
        maxYear,
        minYear,
    };
};

export const Calendar = ({ defaultDate, maxYear, minYear, onChange, ...otherProps }) => {
    const [state, dispatch] = React.useReducer(reducer, { defaultDate, maxYear, minYear }, init);

    const isFirstRun = useRef(true);
    useEffect(() => {
        if (isFirstRun.current) {
            isFirstRun.current = false;
            return;
        }

        onChange(state.selectedDate);
    }, [onChange, state.selectedDate]);

    return (
        <StyledCalendar {...otherProps}>
            <CalendarContext.Provider value={{ state, dispatch, maxYear, minYear }}>
                <StyledControllers>
                    <Years />
                    <Months />
                </StyledControllers>
                <Days />
            </CalendarContext.Provider>
        </StyledCalendar>
    );
};

Calendar.propTypes = {
    defaultDate: PropTypes.string,
    onChange: PropTypes.func,
    width: PropTypes.string,
    height: PropTypes.string,
    shadow: PropTypes.bool,
    maxYear: PropTypes.number,
    minYear: PropTypes.number,
};

/* istanbul ignore next */
Calendar.defaultProps = {
    defaultDate: `${currentDate.getDate()}/${currentDate.getMonth() +
        1}/${currentDate.getFullYear()}`,
    onChange: () => null,
    width: '372px',
    height: '270px',
    shadow: true,
    maxYear: new Date().getFullYear(),
    minYear: 1900,
};
